<template>
    <b-modal size="md"
             centered
             hide-footer
             no-close-on-backdrop
             v-bind:visible="value"
             v-on:hide="hideModal"
             v-on:cancel="hideModal"
             v-on:close="hideModal">
        <template v-slot:modal-title>
            <strong>
                更改事項負責人
            </strong>
        </template>

        <b-form v-on:submit.prevent="submit"
                v-on:reset="reset">
            <b-form-group label-for="owner">
                <template v-slot:label>
                    <font-awesome-icon v-bind:icon="['fad', 'user-tie']"></font-awesome-icon> 事項負責人
                </template>
                <v-select id="owner"
                          class="bg-light"
                          label="name"
                          v-bind:options="users"
                          v-model="ownerInComponent">
                    <template v-slot:search="{ attributes, events }">
                        <input class="vs__search"
                               v-bind:required="!ownerInComponent"
                               v-bind="attributes"
                               v-on="events">
                    </template>
                    <template v-slot:option="{ name, role, email, avatar, }">
                        <div class="d-flex align-items-center">
                            <div class="mr-2">
                                <b-avatar size="2.5em"
                                          variant="light"
                                          v-bind:src="owner ? `${ $config.apiUrl }/${ $config.apiVersion }/user/avatar/${ avatar }` : ''">
                                    <font-awesome-icon class="h-100 w-100 p-3"
                                                       icon="user-tie"
                                                       v-if="!avatar && role === 'vending-admin'">
                                    </font-awesome-icon>
                                    <font-awesome-icon class="h-100 w-100 p-3"
                                                       icon="user-hard-hat"
                                                       v-if="!avatar && role === 'vending-site-manager'">
                                    </font-awesome-icon>
                                </b-avatar>
                            </div>
                            <div class="flex-grow-1">
                                <h6 class="font-weight-bold mb-0">
                                    {{ name }}
                                </h6>
                                <p class="mb-0">
                                    <small>
                                        {{ email }}
                                    </small>
                                </p>
                            </div>
                        </div>
                    </template>
                    <template v-slot:selected-option="{ name, role, email, avatar, }">
                        <div class="d-flex align-items-center">
                            <div class="mr-2">
                                <b-avatar class="bg-white shadow-sm"
                                          size="2.5em"
                                          variant="light"
                                          v-bind:src="owner ? `${ $config.apiUrl }/${ $config.apiVersion }/user/avatar/${ avatar }` : ''">
                                    <font-awesome-icon class="h-100 w-100 p-2"
                                                       icon="user-tie"
                                                       v-if="!avatar && role === 'vending-admin'">
                                    </font-awesome-icon>
                                    <font-awesome-icon class="h-100 w-100 p-2"
                                                       icon="user-hard-hat"
                                                       v-if="!avatar && role === 'vending-site-manager'">
                                    </font-awesome-icon>
                                </b-avatar>
                            </div>
                            <div class="flex-grow-1">
                                <h6 class="font-weight-bold mb-0">
                                    {{ name }}
                                </h6>
                                <p class="mb-0">
                                    <small>
                                        {{ email }}
                                    </small>
                                </p>
                            </div>
                        </div>
                    </template>
                </v-select>
            </b-form-group>

            <div class="text-center mt-3">
                <button class="btn btn-dark px-4"
                        type="submit"
                        v-bind:class="{ 'btn-loading': isLoading }">
                    更改
                </button>
            </div>
        </b-form>
    </b-modal>
</template>

<script>
import {
    BModal,
    BForm, BFormGroup,
    BAvatar,
} from "bootstrap-vue";
import vSelect from "vue-select";
export default {
    name: "ModalChangeOwner",
    components: {
        BModal,
        BForm, BFormGroup,
        BAvatar,
        "v-select": vSelect,
    },
    props: {
        "value": {
            type: Boolean,
            default: false,
        },
        "taskId": {
            type: String,
        },
        "owner": {
            type: Object,
        },
    },
    data () {
        return {
            isLoading: false,
            ownerInComponent: null,
        };
    },
    computed: {
        users () {
            return this.$store.getters["users/all"];
        },
    },
    methods: {
        hideModal () {
            this.$emit("input", false);
        },
        reset () {

        },
        async submit () {
            this.isLoading = true;
            try {
                await this.$store
                    .dispatch(
                        "tasks/edit",
                        {
                            "_id": this.taskId,
                            "owner": this.ownerInComponent._id,
                        }
                    );
            } catch (e) {
                console.error(e);
                this.isLoading = false;
                return;
            }
            this.isLoading = false;
            this.hideModal();
        },
    },
    mounted () {
        this.ownerInComponent = this.owner;
    },
    watch: {
        owner (newVal) {
            this.ownerInComponent = newVal;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
